import { COLORS } from '../utils/colors';

// Shared page section: background, width, scroll-fade, and centred header.
// `alt` picks the off-white background used to alternate between sections.
export const Section = ({ id, title, subtitle, isVisible, alt = false, children }) => (
  <section id={id} className="py-24 px-6 lg:px-20" style={{ backgroundColor: alt ? '#F8FAFC' : 'white' }}>
    <div className="max-w-6xl mx-auto">
      <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-6" style={{ color: COLORS.navy }}>{title}</h2>
          {subtitle && (
            <p className="text-xl max-w-3xl mx-auto" style={{ color: COLORS.slate }}>{subtitle}</p>
          )}
        </div>
        {children}
      </div>
    </div>
  </section>
);

export const Card = ({ children, className = '' }) => (
  <div
    className={`rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 ${className}`}
    style={{
      backgroundColor: 'white',
      border: '1px solid #E2E8F0',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
    }}
  >
    {children}
  </div>
);

export const StatCard = ({ value, label, colorIndex }) => {
  const colors = [COLORS.cantaloupe, COLORS.teal];

  return (
    <Card className="text-center">
      <div className="text-4xl font-bold mb-2" style={{ color: colors[colorIndex % colors.length] }}>
        {value}
      </div>
      <div style={{ color: COLORS.slate }}>{label}</div>
    </Card>
  );
};
